import { FC } from "react";

interface HeartIconSVGProps {
    className?: string;
    strokeWidth?: string;
    fill?: string;
}

const HeartIconSVG: FC<HeartIconSVGProps> = (props) => {
    return (
        <svg
            className={props.className}
            width="36"
            height="36"
            viewBox="0 0 36 36"
            fill={props.fill || "none"}
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M28.5 21C30.735 18.81 33 16.185 33 12.75C33 10.562 32.1308 8.46354 30.5836 6.91637C29.0365 5.36919 26.938 4.5 24.75 4.5C22.11 4.5 20.25 5.25 18 7.5C15.75 5.25 13.89 4.5 11.25 4.5C9.06196 4.5 6.96354 5.36919 5.41637 6.91637C3.86919 8.46354 3 10.562 3 12.75C3 16.2 5.25 18.825 7.5 21L18 31.5L28.5 21Z"
                stroke="currentColor"
                strokeWidth={props.strokeWidth || "2"}
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default HeartIconSVG;
